// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"9d7394c6","116":"454c5749","221":"1e23ad9f","455":"4b6528a3","823":"b7b7a45a","827":"55e02084","977":"c6c3dd23"}[chunkId] + ".chunk.js";
};